import React from 'react';
import Icon from '../../../components/AppIcon';

const QuizNavigation = ({ 
  currentQuestion, 
  totalQuestions, 
  canGoBack, 
  canGoNext, 
  onPrevious, 
  onNext,
  isAnswered,
  isSubmitting = false,
}) => {
  const isLast = currentQuestion === totalQuestions;
  const nextDisabled = !canGoNext || !isAnswered || (isLast && isSubmitting);

  return (
    <div className="bg-card border-t border-border p-3 sm:p-4 md:p-6">
      <div className="max-w-4xl mx-auto flex items-center justify-between gap-3">
        {/* Previous button */}
        <button
          onClick={onPrevious}
          disabled={!canGoBack || currentQuestion === 1 || isSubmitting}
          aria-label="Previous question"
          className={`flex items-center gap-2 px-4 sm:px-6 rounded-xl font-semibold text-sm sm:text-base transition-all duration-200 touch-manipulation border-2 ${
            !canGoBack || currentQuestion === 1 || isSubmitting
              ? 'border-border text-muted-foreground cursor-not-allowed opacity-50'
              : 'border-border text-foreground hover:bg-muted active:scale-95'
          }`}
          style={{ minHeight: '52px', minWidth: '52px' }}
        >
          <Icon name="ChevronLeft" size={20} />
          <span className="hidden sm:inline">Previous</span>
        </button>

        {/* Center: question count */}
        <div className="text-xs sm:text-sm text-muted-foreground text-center">
          {currentQuestion} / {totalQuestions}
        </div>

        {/* Next / Finish button */}
        <button
          onClick={onNext}
          disabled={nextDisabled}
          aria-label={isLast ? 'Finish quiz' : 'Next question'}
          className={`flex items-center gap-2 px-4 sm:px-6 rounded-xl font-semibold text-sm sm:text-base transition-all duration-200 touch-manipulation ${
            nextDisabled
              ? 'bg-muted text-muted-foreground cursor-not-allowed'
              : 'bg-primary text-white hover:opacity-90 active:scale-95 shadow-md'
          }`}
          style={{ minHeight: '52px', minWidth: '52px' }}
        >
          {isLast && isSubmitting ? (
            <>
              <span className="hidden sm:inline">Saving…</span>
              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
            </>
          ) : (
            <>
              <span className="hidden sm:inline">{isLast ? 'Finish' : 'Next'}</span>
              <Icon name={isLast ? 'CheckCircle' : 'ChevronRight'} size={20} />
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default QuizNavigation;